var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInformation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3211 11.4829H13.4619V21.8673H16.3211V11.4829Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4998 8.16053C16.4998 9.0474 15.7784 9.76882 14.8915 9.76882C14.0046 9.76882 13.2832 9.0474 13.2832 8.16053C13.2832 7.27366 14.0046 6.55225 14.8915 6.55225C15.7784 6.55225 16.4998 7.27366 16.4998 8.16053Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8915 29.783C6.67802 29.783 0 23.105 0 14.8915C0 6.67802 6.67802 0 14.8915 0C23.105 0 29.783 6.67802 29.783 14.8915C29.783 23.105 23.105 29.783 14.8915 29.783ZM14.8915 1.32369C7.41267 1.32369 1.32369 7.41267 1.32369 14.8915C1.32369 22.3704 7.41267 28.4594 14.8915 28.4594C22.3704 28.4594 28.4594 22.3704 28.4594 14.8915C28.4594 7.41267 22.3704 1.32369 14.8915 1.32369Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation);
export default __webpack_public_path__ + "static/media/information.301a48a2b6b4041300905f05f9d6b5fc.svg";
export { ForwardRef as ReactComponent };